import React, { useEffect, useState } from "react";
import MDBox from "components/MDBox";
import StorageIcon from "@mui/icons-material/Storage";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import CloudIcon from "@mui/icons-material/Cloud";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import AssessmentIcon from "@mui/icons-material/Assessment";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Slide16 from "assets/images/TheSolutionImages/Slide1/Slide16.png";

function Slide1() {
  const [showScrollIcon, setShowScrollIcon] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const isSmallScreen = window.innerWidth < 1300;

      const isIpadProLandscape =
        window.innerWidth >= 1350 &&
        window.innerWidth <= 1370 &&
        window.innerHeight >= 1000 &&
        window.innerHeight <= 1050;

      setShowScrollIcon(isSmallScreen || isIpadProLandscape);
    };

    handleResize(); // run once on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <MDBox textAlign="left" px={{ xs: 2, md: 4 }} width="100%">
      <MDBox
        width="100%"
        maxWidth={{ xs: "100%", md: "95%", lg: "1350px" }}
        height={{ xs: "auto", md: "640px" }}
        margin="0 auto"
        display="flex"
        flexDirection={{ xs: "column", md: "row" }}
        alignItems={{ xs: "flex-start", md: "center" }}
        justifyContent="space-between"
        gap={4}
        px={{ xs: 2, md: 3 }}
        py={3}
        sx={{
          backgroundColor: "rgba(0, 0, 0, 0)",
          borderRadius: "12px",
        }}
      >
        {/* Left - Scrollable Boxes */}
        <MDBox flex="1" height="100%" pr={1} color="white" display="flex" flexDirection="column">
          <h1
            style={{
              fontSize: "clamp(24px, 5vw, 32px)",
              fontWeight: "bold",
              marginBottom: "16px",
              color: "white",
            }}
          >
            The Solution is SharpWatch®
          </h1>

          <MDBox
            fontSize={{ xs: "18px", md: "24px" }}
            color="#FFFFFF"
            lineHeight={1.6}
            sx={{
              overflowY: "auto",
              maxHeight: { xs: "300px", md: "510px" },
              pr: 1,
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              "&::-webkit-scrollbar": {
                display: "none",
              },
              "& > div": {
                backgroundColor: "rgba(0, 0, 0, 0.77)",
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)",
                borderRadius: "8px",
                padding: "12px",
                display: "flex",
                alignItems: "flex-start",
                marginBottom: "12px",
              },
            }}
          >
            <div>
              <StorageIcon sx={{ marginRight: "12px", fontSize: 36, color: "#FFFFFF" }} />
              Field Proven Software platform that transforms real-time data into actionable
              insights.
            </div>
            <div>
              <ShowChartIcon sx={{ marginRight: "12px", fontSize: 36, color: "#FFFFFF" }} />
              Utilizes existing process data and proprietary subsea leak detection algorithms to
              detect subsea leaks.
            </div>
            <div>
              <CloudIcon sx={{ marginRight: "12px", fontSize: 36, color: "#FFFFFF" }} />
              Delivers proven real-time cloud monitoring capabilities accessible globally from any
              location 24/7.
            </div>
            <div>
              <WarningAmberIcon sx={{ marginRight: "12px", fontSize: 36, color: "#FFFFFF" }} />
              Enables proactive prediction of subsea failures to minimize downtime.
            </div>
            <div>
              <AssessmentIcon sx={{ marginRight: "12px", fontSize: 36, color: "#FFFFFF" }} />
              Tracks Key Performance Indicators for Automated Reporting and Alerts.
            </div>
          </MDBox>

          {showScrollIcon && (
            <MDBox
              display="flex"
              justifyContent="center"
              alignItems="center"
              mt={2}
              sx={{
                animation: "bounce 1.5s infinite",
                color: "#FFFFFF",
                fontSize: "30px",
              }}
            >
              <KeyboardArrowDownIcon fontSize="inherit" />
            </MDBox>
          )}
        </MDBox>

        {/* Right Column - Image */}
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          width={{ xs: "100%", md: "40%" }}
          maxWidth={{ xs: "100%", md: "400px" }}
          mt={{ xs: 3, md: 0 }}
        >
          <img
            src={Slide16}
            alt="SharpWatch Logo"
            style={{
              width: "100%",
              height: "auto",
              borderRadius: "8px",
              objectFit: "contain",
            }}
          />
        </MDBox>
      </MDBox>

      {/* Bounce Animation */}
      <style>
        {`
          @keyframes bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(6px); }
          }
        `}
      </style>
    </MDBox>
  );
}

export default Slide1;
